import type { Routes } from '@angular/router';

export const SOCIAL_POSTS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#modules/posts/views/social-posts-root/social-posts-root.component').then((m) => m.SocialPostsRootComponent),
        children: [],
    },
];
